export default function urlHashMiddleware(track, ...args) {
    const select = args.length < 1 || args[0] === undefined ? function (_ref) {
        const meta = _ref.meta;

        return meta.hash;
    } : args[1];

    return store => next => action => {
        const returnValue = next(action);

        if (!action || !action.meta) {
            return returnValue;
        }

        const event = select(action);

        if (!event) {
            return returnValue;
        }

        track(event, store.getState());

        return returnValue;
    };
}
